"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserValidator = exports.UserChannel = exports.UserRole = void 0;
const util_1 = require("../util");
var UserRole;
(function (UserRole) {
    UserRole["Admin"] = "admin";
    UserRole["Employee"] = "employee";
})(UserRole = exports.UserRole || (exports.UserRole = {}));
var UserChannel;
(function (UserChannel) {
    UserChannel["Slack"] = "slack";
    UserChannel["Mail"] = "mail";
})(UserChannel = exports.UserChannel || (exports.UserChannel = {}));
exports.UserValidator = util_1.generateValidator('User');
//# sourceMappingURL=user.js.map